import axios from 'axios';
import { environment } from '../../services/envoirnment';
import { jwtDecode } from 'jwt-decode';
import { getContactId, getToken } from '../../tools/utils';


const api = axios.create({
  baseURL: environment.REACT_APP_WEB_API,
  
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    "Access-Control-Allow-Origin": "*",
    "Head-Key":environment.REACT_APP_HEADERKEY  
  },
});

const isTokenExpired = (token:string) => {
  try {
    const { exp } = jwtDecode(token);
    return Date.now() >= exp! * 1000;
  } catch {
    return true;
  }
};

api.interceptors.request.use(
  async (config) => {
    const token = await getToken();
    if (token) {
      // if (isTokenExpired(token)) {
      //   localStorage.clear();
      //   window.location.href = '/';
      //   return Promise.reject(console.error('Token expired. Please login again.'));
      // }
      config.headers.Authorization = `Bearer ${token}`;
      config.params = {
        ...config.params,
        contactId: getContactId(),
        
      };
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // if (error.response && error.response.status === 401) {
    //   localStorage.clear();
    //   if(window.location.pathname !== '/'){
    //     window.location.href = '/';
    //   }
    // }
    return Promise.reject(error);
  }
);

export default api;
